import { render } from "./LoginView.vue?vue&type=template&id=bc5b3582&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=bc5b3582&scoped=true&lang=css"

import exportComponent from "../../../../kaicms_vue_250623/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5b3582"]])

export default __exports__